import React from 'react';

var WebGameColBodyWr = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: 'bottom-inner-wrapper' }, children);
};

export { WebGameColBodyWr };
